import React, { useState } from "react";
import ReactDatatable from "@mkikets/react-datatable";
import { useGetSwapQuery, useDeleteSwapMutation } from "../../../redux/swapApi";
import { Button, Modal } from "react-bootstrap";
import EditSwap from "../../partial/EditSwap";
import AddSwap from "../../partial/AddSwap";
import { toast } from "react-toastify";

import { useTranslation } from "react-i18next";

function Swap() {
    const { t } = useTranslation();
    const { data: apiResponse } = useGetSwapQuery();

    const users = apiResponse?.data || [];

    // Edit Modal State
    const [showEdit, setShowEdit] = useState(false);
    const [showAdd, setShowAdd] = useState(false);
    const [editData, setEditData] = useState({});

    // Delete Modal State
    const [showDelete, setShowDelete] = useState(false);
    const [deleteData, setDeleteData] = useState(null);
    const [deleteSwap] = useDeleteSwapMutation();

    const handleEdit = (network) => {
        setEditData(network);
        setShowEdit(true);
    };

    const handleDeleteClick = (record) => {
        setDeleteData(record);
        setShowDelete(true);
    };

    const handleConfirmDelete = async () => {
        try {
            const response = await deleteSwap({ id: deleteData.id }).unwrap();
            if (response.status) {
                toast.success(response.message || "Swap rate deleted successfully!");
                setShowDelete(false);
            } else {
                toast.error(response.message || "Failed to delete swap rate");
            }
        } catch (error) {
            toast.error("Error deleting swap rate");
            console.error("Error deleting swap rate:", error);
        }
    };

    const columns = [
        {
            key: "srno.",
            text: t('sr_no'),
            className: "sr_no.",
            align: "left",
            sortable: true,
            cell: (row, index) => index + 1,
        },
        {
            key: "from_coin",
            text: t('from_coin'),
            className: "from_coin",
            align: "left",
            sortable: true,
            cell: (record) => {
                return <><img style={{ width: "20px", height: "20px" }} src={record.from_coin_logo} alt="" /> {" "}{record.from_coin_name}</>;
            },
        },
        {
            key: "to_coin",
            text: t('to_coin'),
            className: "to_coin",
            align: "left",
            sortable: true,
            cell: (record) => {
                return <><img style={{ width: "20px", height: "20px" }} src={record.to_coin_logo} alt="" /> {" "}{record.to_coin_name}</>;
            },
        },
        {
            key: "rate",
            text: t('rate'),
            className: "rate",
            align: "left",
            sortable: true,
            cell: (record) => {
                return <>1 {record.from_coin_name} = {record.swap_rate} {record.to_coin_name}</>;
            },
        },
        {
            key: "status",
            text: t('status'),
            className: "status",
            align: "left",
            sortable: true,
        },
        {
            key: "action",
            text: t('actions'),
            className: "Action d-flex",
            align: "left",
            sortable: true,
            cell: (record) => {
                return (
                    <>
                        <Button variant="info" size="sm" className="me-1" onClick={() => handleEdit(record)}>
                            {t('edit')}
                        </Button>
                        <Button variant="danger" size="sm" className="me-1" onClick={() => handleDeleteClick(record)}>
                            {t('delete')}
                        </Button>
                    </>
                );
            },
        },
    ];

    const config = {
        page_size: 5,
        length_menu: [5, 10, 20, 50],
        filename: "Fund Request List",
        no_data_text: t('no_record_found'),
        button: {
            // print: true,
            // csv: true,
        },
        language: {
            filter: t('search_in_records'),

            pagination: {
                first: t('first'),
                previous: t('previous'),
                next: t('next'),
                last: t('last'),
            },
        },
        show_length_menu: true,
        show_filter: false,
        show_pagination: true,
        show_info: true,
    };

    return (
        <section className="section dashboard">
            <div className="pagetitle d-flex align-items-center justify-content-between mb-4">
                <h1>{t('swap')}</h1>
                <Button variant="primary" onClick={() => setShowAdd(true)}>
                    {t('add_swap')}
                </Button>
            </div>

            <div className="card">
                <div className="card-body pt-4">
                    <ReactDatatable
                        key={`datatable-aa`}
                        config={config}
                        records={users}
                        columns={columns}
                        dynamic={false}

                    />

                </div>
            </div>

            <EditSwap
                show={showEdit}
                onHide={() => setShowEdit(false)}
                swap={editData}
            />

            <AddSwap
                show={showAdd}
                onHide={() => setShowAdd(false)}
            />

            <Modal show={showDelete} onHide={() => setShowDelete(false)}>
                <Modal.Header closeButton>
                    <Modal.Title>{t('confirm_delete') || "Confirm Delete"}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {t('are_you_sure_you_want_to_delete_this_record') || "Are you sure you want to delete this record?"}
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowDelete(false)}>
                        {t('cancel') || "Cancel"}
                    </Button>
                    <Button variant="danger" onClick={handleConfirmDelete}>
                        {t('delete') || "Delete"}
                    </Button>
                </Modal.Footer>
            </Modal>
        </section>
    );
}

export default Swap;
